(function(){
    function cleanAndInjectRating(){
      document.querySelectorAll('.ct-card .jdgm-prev-badge').forEach(function(badge){
        var stars = badge.querySelector('.jdgm-prev-badge__stars');
        if (!stars) return;
        while (stars.previousSibling) {
          badge.removeChild(stars.previousSibling);
        }
        if (!badge.querySelector('.ct-card__rating-num')) {
          var rating = badge.getAttribute('data-average-rating');
          if (rating && parseFloat(rating) > 0) {
            var num = document.createElement('span');
            num.className = 'ct-card__rating-num';
            num.textContent = parseFloat(rating).toFixed(1);
            if (stars.nextSibling) {
              badge.insertBefore(num, stars.nextSibling);
            } else {
              badge.appendChild(num);
            }
          }
        }
      });
    }

    function initCardCarousels(){
      if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return; // touch only
      var AUTOPLAY_MS = 5000;
      document.querySelectorAll('.ct-card [data-ct-track]').forEach(function(track){
        if (track.__ctCar) return;
        var slides = track.querySelectorAll('.ct-card__slide');
        if (slides.length < 2) return;
        track.__ctCar = true;

        var index = 0, count = slides.length, timer = null, lastSwipe = 0;

        function go(i){
          index = (i % count + count) % count;
          track.style.transform = 'translateX(' + (-index * 100) + '%)';
        }
        function nextSlide(){ go(index + 1); }
        function start(){ if (timer) return; timer = setInterval(nextSlide, AUTOPLAY_MS); }
        function stop(){ if (timer){ clearInterval(timer); timer = null; } }

        // Swipe (pauses autoplay while the finger is down, resumes on release)
        var x0 = 0, y0 = 0, swiping = false;
        track.addEventListener('touchstart', function(e){
          var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; swiping = true; stop();
        }, { passive: true });
        track.addEventListener('touchend', function(e){
          if (!swiping) return; swiping = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - x0, dy = t.clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
            lastSwipe = Date.now();
            if (dx < 0) nextSlide(); else go(index - 1);
          }
          start();
        }, { passive: true });

        // A swipe must not trigger the wrapping <a> navigation; a real tap still does.
        track.addEventListener('click', function(e){
          if (Date.now() - lastSwipe < 350){ e.preventDefault(); e.stopPropagation(); }
        }, true);

        // Only run the timer while the card is on screen (saves battery on long grids)
        if ('IntersectionObserver' in window){
          var card = track.closest('.ct-card') || track;
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(en){ if (en.isIntersecting) start(); else stop(); });
          }, { threshold: 0.25 });
          io.observe(card);
        } else {
          start();
        }

        go(0);
      });
    }

    function initCtCards(){
      cleanAndInjectRating();
      initCardCarousels();
      document.querySelectorAll('.ct-card[data-product-id]').forEach(function(card){
        if (card.__ctVariantBound) return;
        card.__ctVariantBound = true;
        var sel = card.querySelector('[data-ct-variant]');
        if(!sel) return;
        sel.addEventListener('change', function(){
          var o = sel.options[sel.selectedIndex];
          var priceEl = card.querySelector('[data-ct-price]');
          var compEl = card.querySelector('[data-ct-compare]');
          var savePillEl = card.querySelector('[data-ct-save-pill]');
          var prepaidEl = card.querySelector('[data-ct-prepaid]');
          var atcBtn = card.querySelector('[data-ct-atc]');
          var atcTxt = card.querySelector('[data-ct-atc-text]');
          var cRaw = parseInt(o.dataset.compareRaw)||0;
          var pRaw = parseInt(o.dataset.priceRaw);
          var avail = o.dataset.avail === 'true';

          if(priceEl) priceEl.textContent = o.dataset.price;
          if(cRaw > pRaw){
            if(compEl){ compEl.textContent = o.dataset.compare; compEl.style.display=''; }
            if(savePillEl){ savePillEl.textContent = o.dataset.save + ' OFF'; savePillEl.style.display=''; }
          } else {
            if(compEl) compEl.style.display='none';
            if(savePillEl) savePillEl.style.display='none';
          }
          if(prepaidEl && o.dataset.prepaid){
            prepaidEl.textContent = '+' + o.dataset.prepaid + ' OFF on Prepaid';
          }
          if(atcBtn){ atcBtn.disabled = !avail; }
          if(atcTxt){ atcTxt.textContent = avail ? 'Add' : 'Sold out'; }
        });
      });
    }
    window.__ctRevampCardInit_run = initCtCards;
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCtCards);
    else initCtCards();
    document.addEventListener('shopify:section:load', initCtCards);
    setTimeout(function(){ cleanAndInjectRating(); initCardCarousels(); }, 1000);
    setTimeout(function(){ cleanAndInjectRating(); initCardCarousels(); }, 3000);
  })();